import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offer-flight-details-modal" }

import type { FlightSegment } from '@/interfaces/checkout/offer-data';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import CheckoutFlightDetails from '@lmt-rpb/CheckoutFlightDetails/CheckoutFlightDetails.vue';
import { useTranslations } from 'src/storybook/src/composables/translations';
interface Props {
	inboundFlightSegments: FlightSegment[];
	outboundFlightSegments: FlightSegment[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'OfferFlightDetailsModal',
  props: {
    inboundFlightSegments: {},
    outboundFlightSegments: {}
  },
  emits: ['flightDetailsModalOpen'],
  setup(__props: any) {



const { translate } = useTranslations();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseModal, {
      class: "offer-flight-details-modal__modal",
      "header-title": _unref(translate)('offer.flight.details'),
      "with-open-button": "",
      "open-button-props": {
				label: _unref(translate)('offer.flight.details'),
				bold: true,
			},
      onOpen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('flightDetailsModalOpen')))
    }, {
      default: _withCtx(() => [
        _createVNode(CheckoutFlightDetails, {
          class: "offer-flight-details-modal__flight-details",
          "inbound-flight": _ctx.inboundFlightSegments,
          "outbound-flight": _ctx.outboundFlightSegments
        }, null, 8 /* PROPS */, ["inbound-flight", "outbound-flight"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["header-title", "open-button-props"])
  ]))
}
}

})